var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoinMarketCap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "url(#paint0_linear_10019_6426)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10019_6426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6662 52.2636C68.5327 52.9457 67.2103 53.0698 66.2028 52.5116C64.9434 51.7674 64.1877 50.093 64.1877 47.7984V40.7907C64.1877 37.4419 62.8653 35.0233 60.5984 34.4031C56.7572 33.2868 53.8605 37.938 52.79 39.6744L45.9892 50.4031V37.1938C45.9262 34.155 44.9187 32.3566 43.0295 31.7985C41.7701 31.4264 39.881 31.6124 38.0548 34.3411L22.8789 58.2791C20.8638 54.4961 19.7933 50.2791 19.7933 46C19.7933 31.5504 31.5688 19.8295 45.9892 19.8295C60.4095 19.8295 72.185 31.5504 72.185 46V46.062V46.124C72.3109 48.9147 71.4293 51.1473 69.6662 52.2636ZM77.9783 46V45.938V45.876C77.9153 28.3256 63.558 14 45.9892 14C28.3573 14 14 28.3256 14 46C14 63.6124 28.3573 78 45.9892 78C54.1124 78 61.7948 74.9612 67.7141 69.4419C68.9105 68.3256 68.9735 66.5271 67.84 65.3488C66.7695 64.1705 64.9434 64.1085 63.7469 65.1628C63.7469 65.1628 63.7469 65.1628 63.6839 65.2248C58.8982 69.6899 52.4751 72.2325 45.8632 72.2325C38.1178 72.2325 31.191 68.8837 26.4052 63.5504L40.0699 41.969V51.9535C40.0699 56.7287 41.959 58.2791 43.5333 58.7132C45.1076 59.1473 47.5005 58.8372 50.0823 54.8062L57.5758 42.8372C57.8277 42.4651 58.0166 42.093 58.2685 41.845V47.9225C58.2685 52.3876 60.0946 55.9845 63.2431 57.7209C66.0768 59.3333 69.6662 59.1473 72.6258 57.3488C76.2781 54.9922 78.2302 50.8992 77.9783 46Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10019_6426",
    x1: 92,
    y1: 0.00000274181,
    x2: -0.00000274181,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10019_6426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinMarketCap);
export default __webpack_public_path__ + "static/media/CoinMarketCap.95a8ce9ae8e6d2fb418c33d6f39df3c2.svg";
export { ForwardRef as ReactComponent };